import React, { memo } from 'react';
import Spinner from 'Shared/components/Spinner';

import './IsFileUploadingLoader.scss';

function IsFileUploadingLoader() {
  const handleLoaderClick = event => event.stopPropagation();

  return (
    <div
      className="is-file-uploading-loader d-flex flex-column justify-content-center align-items-center position-absolute w-100"
      onClick={handleLoaderClick}
    >
      <Spinner activeIf />
    </div>
  );
}

export default memo(IsFileUploadingLoader);
